export default function (value) {
  if (typeof value === 'string') {
    return value.trim().split(' ').map((word) => {
      return word[0].toUpperCase() + word.substring(1).toLowerCase()
    }).join(' ')
  }
}
